
export const ADD_TO_CART = 'add to cart'
export const REMOVE_FROM_CART = 'remove from cart'

export const SET_PRODUCTS = 'set products'

export const SET_CART = 'set cart'

export const SET_CHECKOUT = 'set checkout'